import { useTheme } from '@emotion/react';
import { Box, Stack, Typography, useMediaQuery } from '@mui/material';
import React from 'react';

const DashboardCard = ({ handleClick, Icon = <></>, total, title }) => {
	const theme = useTheme();

	const isAbove735 = useMediaQuery('(min-width:736px)');
	const isAbove1150 = useMediaQuery('(min-width:1150px)');

	const heightProps = {
		xs: isAbove735 ? '12em' : '11em',
		md: isAbove1150 ? '14em' : '12em',
	};

	return (
		<Box
			onClick={handleClick}
			sx={{
				borderRadius: '15px',
				border: `1px solid ${theme.palette.divider}`,

				backgroundColor: theme.palette.background.paper,
				height: heightProps,
				padding: '1.25em',
				transition: 'background-color 0.3s',
				'&:hover': {
					backgroundColor: theme.palette.action.hover,
					cursor: 'pointer',
				},
			}}
		>
			<Stack height='100%' justifyContent={'space-between'}>
				<Typography
					variant='card_header'
					sx={{
						minHeight: '2.6em',
						display: '-webkit-box',
						WebkitLineClamp: 2,
						WebkitBoxOrient: 'vertical',
						overflow: 'hidden',
						textOverflow: 'ellipsis',
					}}
				>
					{title}
				</Typography>
				<Stack
					direction='row'
					justifyContent='space-between'
					alignItems='center'
					height={'60px'}
				>
					<Typography variant='card_h4'>{total}</Typography>
					<Icon />
				</Stack>
				<Typography sx={{ color: theme.palette.primary.main }}>{'View all'}</Typography>
			</Stack>
		</Box>
	);
};
export default DashboardCard;
